export default __webpack_public_path__ + "static/media/GA2.198337cf.png";